export default __webpack_public_path__ + "static/media/b-3.43bdf52f.png";